/**
 * walletBus.js — cross-tab wallet + passbook revalidation bus.
 *
 * Iteration 87 — companion to listingBus. Emitted by any surface that
 * completes a money-moving action (kid checkout, marketplace purchase,
 * parent → kid transfer, sale-fulfillment). Subscribed by dashboards
 * and ledgers so passbook rows, running balances, and stats cards
 * (wallet, earnings, sold count) refresh instantly across every mounted
 * view and every open tab.
 *
 * Payload shape: { scope: 'kid' | 'household', kid_id?, parent_id?, reason }
 * — subscribers decide whether to refetch based on scope + ids they care
 * about.
 */

const CHANNEL = "wallet:updates";
let bc = null;
try {
  if (typeof BroadcastChannel !== "undefined") {
    bc = new BroadcastChannel(CHANNEL);
  }
} catch { /* fall back to storage events */ }

const localSubs = new Set();

export function publishWalletUpdate(payload = {}) {
  const evt = { ts: Date.now(), ...payload };
  localSubs.forEach((cb) => { try { cb(evt); } catch { /* isolate */ } });
  try { bc?.postMessage(evt); } catch { /* channel closed */ }
  try { window.localStorage.setItem(CHANNEL, JSON.stringify(evt)); } catch { /* private mode */ }
}

export function subscribeWalletUpdates(cb) {
  if (typeof cb !== "function") return () => {};
  localSubs.add(cb);
  const onBC = (e) => { if (e?.data) cb(e.data); };
  const onStorage = (e) => {
    if (e.key !== CHANNEL || !e.newValue) return;
    try { cb(JSON.parse(e.newValue)); } catch { /* ignore */ }
  };
  bc?.addEventListener?.("message", onBC);
  window.addEventListener("storage", onStorage);
  return () => {
    localSubs.delete(cb);
    bc?.removeEventListener?.("message", onBC);
    window.removeEventListener("storage", onStorage);
  };
}
